import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { Spin } from "antd";
import { connect } from "react-redux";
import Moment from "moment-jalaali";

import { Modals } from "scripts/settings";
import API from "scripts/api";
import Icons from "scripts/icons";
import Resources from "scripts/resources";

import LoadMore from "components/loadmore";
import Empty from "pages/empty";
import PaymentModal from "modals/payment";

const Component = ({ user }) => {
	const initialState = {
		jobs: [],
		list: [],
	};
	const [state, setState] = useState(initialState);
	const { payment, jobs, list, loaded, loading, loadMore, page } = state;
	const { pathname } = useLocation();
	const navigate = useNavigate();

	const handleData = (params) => {
		if (!loading) {
			setState((prevState) => ({
				...prevState,
				loading: false,
				loaded: false,
			}));

			params.user = user.id;
			params.pageSize = process.env.REACT_APP_PAGE_SIZE;

			API.payment
				.list(params)
				.then(({ data, meta: { currentPage, perPage, total } }) => {
					setState((prevState) => ({
						...prevState,
						loaded: true,
						loading: false,
						loadMore: total > currentPage * perPage,
						list: [...list, ...data],
						page: currentPage,
					}));
				})
				.catch(() => {
					setState((prevState) => ({ ...prevState, loading: false }));
				});
		}
	};

	const handleModal = (selected, reload = false) => {
		if (reload) {
			handleData({});
		} else {
			if (selected) {
				setState((prevState) => ({ ...prevState, payment: selected }));
				navigate(`${pathname}#${Modals.PAYMENT}_${Modals.EDIT}`);
			} else {
				navigate(`${pathname}#${Modals.PAYMENT}`);
			}
		}
	};

	const handleLoadmore = () => {
		handleData({ page: page + 1 });
	};

	const componentDidMount = () => {
		API.profile
			.myJobs({ paginate: false })
			.then(({ data }) => {
				setState((prevState) => ({
					...prevState,
					jobs: data.map(({ id, title }) => ({ value: id, label: title })),
				}));
			})
			.catch(() => {
				setState((prevState) => ({ ...prevState, loading: false }));
			});

		handleData({});
	};

	useEffect(componentDidMount, []);

	return (
		<>
			<div className="panel-payment">
				<div className="row">
					<div className="btn-container">
						<button className="create col-12" onClick={() => handleModal()}>
							{`${Resources.add} ${Resources.pay}${Resources.y}`}
						</button>
					</div>
					{loaded ? (
						list.length ? (
							<>
								{list.map((payment) => {
									const {
										id,
										code,
										subject,
										amount,
										traceNumber,
										depositedTo,
										description,
										status,
										paymentDate,
									} = payment;
									return (
										<div className="col-12 col-md-6" key={id}>
											<ul>
												<li>
													<span className="property">
														<Icons.ChartSuccess doutone="true" />
														{`${Resources.subject}:`}
													</span>
													<span className="value">
														{subject === "ladder"
															? Resources.manageModal.ladderAd
															: subject === "subscription"
															? `${Resources.buy} ${Resources.subscription}`
															: `${Resources.jobs} ${Resources.special}`}
													</span>
												</li>
												<li>
													<span className="property">
														<Icons.Moneys doutone="true" />
														{`${Resources.amount}:`}
													</span>
													<span className="value">{amount}</span>
												</li>
												<li>
													<span className="property">
														<Icons.Calendar doutone="true" />
														{`${Resources.date}:`}
													</span>
													<span className="value">
														{Moment(paymentDate).format(
															process.env.REACT_APP_DATE_FORMAT_JALALI
														)}
													</span>
												</li>
												<li>
													<span className="property">
														<Icons.Card doutone="true" />
														{`${Resources.deposit} ${Resources.toBe} ${Resources.bankCard}:`}
													</span>
													<span className="value">{depositedTo}</span>
												</li>
												<li>
													<span className="property">
														<Icons.Document doutone="true" />
														{`${Resources.code} ${Resources.tracking} ${Resources.bank}${Resources.y}:`}
													</span>
													<span className="value">{traceNumber}</span>
												</li>
												<li>
													<span className="property">
														<Icons.Status doutone="true" />
														{`${Resources.status}:`}
													</span>
													<span
														className={`value ${
															status === "succeed"
																? "success"
																: status === "pending"
																? "waiting"
																: "error"
														}`}
													>
														{status === "approved"
															? `${Resources.confirm} ${Resources.toBe}`
															: status === "pending"
															? Resources.pendingAdmin
															: `${Resources.reject} ${Resources.toBe}`}
													</span>
												</li>
												<li>
													<button
														className="edit"
														onClick={() => handleModal(payment)}
													>
														{Resources.edit}
													</button>
												</li>
											</ul>
										</div>
									);
								})}

								{loadMore && (
									<LoadMore onScreen={handleLoadmore} loading={loading} />
								)}
							</>
						) : (
							<div className="col-12">
								<Empty />
							</div>
						)
					) : (
						<Spin className="page-loading col-12" />
					)}
					<PaymentModal
						data={payment}
						onUpdate={handleModal}
						options={{ jobs }}
					/>
				</div>
			</div>
		</>
	);
};

export default connect((state) => {
	return {
		user: state.user,
	};
})(Component);
